'use client'
import { inter } from '@/config/fonts'
import dynamic from 'next/dynamic'
const Select = dynamic(() => import('react-select'), { ssr: false })

interface Props {
  title: string
  name: string
}

const ReactSelect = (compProps: any) => {
  const { title, name, labelColor } = compProps

  return (
    <>
      <label className={`${inter.className} ${labelColor}`} htmlFor={`${name}`}>
        {title}
      </label>
      <Select {...compProps} />
    </>
  )
}

export default ReactSelect
